module.exports = __webpack_public_path__ + "img/hyperbolic_curve.8f65052e.png";